<template>
  <div
    ref="filterBox"
    :class="['search-box', 'as-flex' ,'flex-vertical','main-center','cross-center']"
  >
    <template v-for="(filterType,index) in filterTypes">
      <div
        v-if="filterTypesModel[filterType.value]"
        :key="index"
        class="search-row as-flex flex-horizontal main-start cross-start"
      >
        <div class="filter-title f-2 as-flex main-center cross-center">
          <p>{{filterType.title}}</p>
        </div>
        <div class="as-flex main-start cross-center">
          <div class="filter-list as-flex flex-horizontal main-start cross-center">
            <template v-for="filterValue in filterType.list || []">
              <template v-if="filterValue.id === '-1'">
                <el-popover width="600" :key="filterValue.id" placement="bottom" trigger="click">
                  <div class="popover-box as-flex flex-vertical main-center">
                    <slider
                      :type="filterType.value"
                      @confirm="(res)=>{toggleFilter(filterType.value,filterValue.id,res)}"
                    ></slider>
                  </div>
                  <span
                    slot="reference"
                    :class="['list-item',currentFilterFlag[filterType.value]===filterValue.id?'is-filter-active':'', 'f-2', 'as-flex' ,'flex-horizontal', 'main-center', 'cross-center']"
                    :ref="filterType.value + filterValue.id"
                  >{{filterValue.name}}</span>
                </el-popover>
              </template>
              <template v-else>
                <span
                  slot="reference"
                  @click="toggleFilter(filterType.value,filterValue.id)"
                  :key="filterValue.id"
                  :class="['list-item',currentFilterFlag[filterType.value]===filterValue.id?'is-filter-active':'', 'f-2', 'as-flex' ,'flex-horizontal', 'main-center', 'cross-center']"
                  :ref="filterType.value + filterValue.id"
                >{{filterValue.name}}</span>
              </template>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { boxArray, yearArray } from "../../config/boxAndYearMappingArray";
import { clone } from "lodash";
import slider from "./slider";
import tagApi from "../../api/tagApi.js";
import surveyApi from "../../api/surveyApi.js";

export default {
  name: "filterBox",
  props: {
    currentFilterFlag: {},
    filterTypesModel: {}
  },
  components: {
    slider: slider
  },
  data() {
    return {
      tagApi: new tagApi(),
      surveyApi: new surveyApi(),
      currentFilter: {},
      //init filter config
      filterTypes: {
        tags: {
          title: "标签",
          value: "tags",
          list: []
        },
        location: {
          title: "地区",
          value: "location",
          list: []
        },
        box: {
          title: "票房",
          value: "box",
          list: []
        },
        year: {
          title: "年份",
          value: "year",
          list: []
        },
        orderby: {
          title: "排序",
          value: "orderby",
          list: []
        },
        cycle: {
          title: "周期",
          value: "cycle",
          list: []
        }
      }
    };
  },
  methods: {
    async initFilterConfig() {
      //gei every filter tag`s content by api
      let tags = await this.tagApi.getTypeTags();
      if (tags.code === 200) {
        this.filterTypes.tags.list = [{ name: "不限", id: "" }].concat(
          tags.data
        );
      } else {
        this.isLoadingMovie = false;
        throw new Error("获取类型标签错误");
      }
      let location = await this.tagApi.getDistrictTags();
      if (location.code === 200) {
        this.filterTypes.location.list = [{ name: "不限", id: "" }].concat(
          location.data
        );
      } else {
        this.isLoadingMovie = false;
        throw new Error("获取地区标签错误");
      }
      let boxes = await this.surveyApi.getBoxTags();
      if (boxes.code === 200) {
        this.filterTypes.box.list = [
          { name: "不限", id: "" },
          { name: "自定义", id: "-1" }
        ].concat(boxes.data.records);
      } else {
        this.isLoadingMovie = false;
        throw new Error("获取票房标签错误");
      }
      this.filterTypes.year.list = [
        { name: "不限", id: "" },
        { name: "自定义", id: "-1" },
        { name: "2019", id: "2019" },
        { name: "2018", id: "2018" },
        { name: "2017", id: "2017" },
        { name: "2016", id: "2016" },
        { name: "2015", id: "2015" },
        { name: "2014", id: "2014" }
      ];
      this.filterTypes.orderby.list = [
        { name: "上映时间", id: "" },
        { name: "票房", id: "box" },
        { name: "认知", id: "awareness" },
        { name: "兴趣", id: "interest" },
        { name: "首选", id: "primary" },
        { name: "喜爱", id: "rating" },
        { name: "推荐", id: "recommendation" },
        { name: "预期达成", id: "expectation" }
      ];
      this.filterTypes.cycle.list = [
        { name: "默认", id: "" },
        { name: "映前4周", id: "-4.0" },
        { name: "映前3周", id: "-3.0" },
        { name: "映前2周", id: "-2.0" },
        { name: "映前1周", id: "-1.0" },
        { name: "上映当周", id: "0.0" },
        { name: "映后1周", id: "1.0" }
        // { name: "映后2周", id: "2.0" }
      ];
    },
    handleCustomizeFilter(type, value) {
      this.filterTypes[type].list[1].name = `${value[0].label}-${
        value[1].label
      }`;
      if (type === "box") {
        this.currentFilter.range_box = value.map(item => {
          return item.value;
        });
      } else if (type === "year") {
        this.currentFilter.range_year = value.map(item => {
          return item.value;
        });
      }
    },
    toggleFilter(filterType, filterValue, customizedValues) {
      //如果是自定义标签，交由处理自定义标签相关函数处理
      if (
        (filterType === "year" && filterValue === "-1") ||
        (filterType === "box" && filterValue === "-1")
      ) {
        this.handleCustomizeFilter(filterType, customizedValues);
      }
      //如果选择了年份/票房的非自定义选项，清除自定义相关数据
      if (["box", "year"].includes(filterType) && filterValue !== "-1") {
        this.filterTypes[filterType].list[1].name = "自定义";
        if (filterType === "box") {
          this.currentFilter.range_box = [];
        } else if (filterType === "year") {
          this.currentFilter.range_year = [];
        }
      }
      // let from = clone(this.currentFilter);
      this.currentFilter[filterType] = filterValue;
      this.currentFilter = clone(this.currentFilter);
    },
    clickDisabledFilter(filterType, filterValue) {
      // Toast({
      //   message: ""
      // });
    }
  },
  async created() {
    this.currentFilter = clone(this.currentFilterFlag);
    await this.initFilterConfig();
    if (this.currentFilterFlag.box === "-1") {
      //票房自定义
      let value = this.currentFilterFlag.range_box.map(item => {
        return boxArray.find(sub_item => {
          return sub_item.value === item;
        });
      });
      this.handleCustomizeFilter("box", value);
    }
    if (this.currentFilterFlag.year === "-1") {
      //年份自定义
      let value = this.currentFilterFlag.range_year.map(item => {
        return yearArray.find(sub_item => {
          return sub_item.value === item;
        });
      });
      this.handleCustomizeFilter("year", value);
    }
  },
  watch: {
    currentFilter: {
      handler: function(to, from) {
        this.$emit("executeFilter", to);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.search-box {
  background-color: #ffffff;
  width: 100%;
}
.search-row {
  // height: 40px;
  padding: 10px 10px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  overflow: hidden;
  .filter-title {
    border: 1px solid #979797;
    border-radius: 15px;
    border-top-right-radius: 0;
    background-color: #707070;
    height: 30px;
    white-space: nowrap;
    padding: 0px 15px;
    color: #fff;
  }

  .filter-list {
    // height: 0.9rem;
    // margin-bottom: -0.02rem;
    width: 100%;
    flex-wrap: wrap;
    white-space: nowrap;
    padding-left: 5px;
    .list-item {
      color: #666666;
      white-space: nowrap;
      margin: 0 5px;
      padding: 0 10px;
      height: 30px;
      // line-height: 0.5rem;
      border: 1px solid rgba(0, 0, 0, 0);
      border-radius: 15px;
      cursor: pointer;
      &.is-filter-active {
        background-color: #cceafc;
        border: 1px solid rgba(0, 0, 0, 0);
        color: #008cd6;
      }
      &.is-disabled {
        background-color: #ffffff;
        border: 1px solid #dddddd;
        color: #dddddd;
      }
    }
  }
  /deep/ .el-popover__reference {
    border: none;
  }
}
</style>
